import { isDocumentVisible } from './helpers';

export function onPageHideHandler() {
  if (!window.BPFTracking.terminatingEventSent) {
    window.BPFTracking.terminatingEventSent = true;
  }
}

export function onVisibilityChangeHandler() {
  if (isDocumentVisible()) {
    window.BPFTracking.terminatingEventSent = false;
  } else {
    onPageHideHandler();
  }
}

export function instrumentedClickHandler(e) {
  const bpfAnalytics = 'data-bpf-analytics';
  let element;

  // find nearest element ancestor with a data-bpf-analytics attribute
  for (element = e.target; element && element !== document; element = element.parentNode) {
    if (element.getAttribute(bpfAnalytics)) {
      break;
    }
  }

  if (!element || element === document) { return; }
  const analyticsData = element.getAttribute(bpfAnalytics);
  if (!analyticsData) { return; }

  const eventPayloads = [].concat(analyticsData);
  eventPayloads.forEach(eventPayload => {
    try {
      const parsedLoad = JSON.parse(eventPayload);
      const eventType = parsedLoad['event_type'];
      const eventName = parsedLoad['event_name'];
      if (!eventName) { throw 'Cannot fire an event without a name' }

    } catch (error) {
      if (typeof sentry  !== 'undefined') {
        sentry.hub.captureException(error, scope => {
          scope.clear();
          scope.setTransactionName("Analytics: InstrumentedClickHandler");
          scope.setContext("Dom Info", {
            id: element.id,
            classList: element.classList,
            payload: eventPayload,
          });
          return scope;
        });
      }

      return;
    }
  });
}
